export const drawRect = (detections, ctx) =>{

    detections.forEach(prediction => {

         //getting the predirtciton results

         const [x,y,width,height] = prediction['bbox'];
         const text = prediction['class'];
         
         //decorating shit
         const color = '#' + Math.floor(Math.floor(Math.random()*1677316).toString(16));
         ctx.strokeStyle = color
         ctx.font = '18px Arial'
         ctx.fillStyle = color

        //draw rect and bunch of text
         ctx.beginPath();
         ctx.fillText(text,x,y);
         ctx.rect(x,y, width, height);
         ctx.stroke();



    })
        
   
    

   

}